export const CREDIT_CARD_PAYMENT_ERROR_CODE = 4013;
export const DOA_EXCEED_LIMIT = 4011;
export const INVALID_SAP = 1006;
export const UNKNOWN_ERROR_CODE = 1;
export const PRODUCT_ACCESS_ERROR = 3002;
